/**
 * @generated SignedSource<<49e8a4bd6400e1a8a65645d0912fb202>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useBootloaderQuery$variables = {
  configValueKeys: ReadonlyArray<string | null>;
  tenantId: string;
  tenantIds?: ReadonlyArray<string> | null;
};
export type useBootloaderQuery$data = {
  readonly _routes: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly context: ReadonlyArray<string> | null;
        readonly exact: boolean | null;
        readonly handler: string;
        readonly id: string;
        readonly identifier: string;
        readonly path: string | null;
        readonly sort: string;
      } | null;
    } | null> | null;
  } | null;
  readonly _tenant: {
    readonly " $fragmentSpreads": FragmentRefs<"CoreApp__tenant">;
  } | null;
  readonly _viewer: {
    readonly id: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"CoreApp__viewer" | "FeatureFlagProvider_features">;
  } | null;
  readonly routes: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly identifier: string;
        readonly path: string;
        readonly sort: string;
      } | null;
    } | null> | null;
  } | null;
  readonly tenant: {
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"CoreApp_tenant" | "CoreNav_nav">;
  } | null;
  readonly viewer: {
    readonly id: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"CoreApp_viewer">;
  } | null;
};
export type useBootloaderQuery = {
  response: useBootloaderQuery$data;
  variables: useBootloaderQuery$variables;
};
const node: ConcreteRequest = function () {
  var v0 = {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "configValueKeys"
    },
    v1 = {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "tenantId"
    },
    v2 = {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "tenantIds"
    },
    v3 = {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    v4 = [{
      "kind": "Variable",
      "name": "tenantIds",
      "variableName": "tenantIds"
    }],
    v5 = [{
      "kind": "Variable",
      "name": "tenantId",
      "variableName": "tenantId"
    }],
    v6 = [{
      "kind": "Variable",
      "name": "id",
      "variableName": "tenantId"
    }],
    v7 = {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "path",
      "storageKey": null
    },
    v8 = {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "identifier",
      "storageKey": null
    },
    v9 = {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sort",
      "storageKey": null
    },
    v10 = {
      "alias": null,
      "args": v5 /*: any*/,
      "concreteType": "RouteConnection",
      "kind": "LinkedField",
      "name": "routes",
      "plural": false,
      "selections": [{
        "alias": null,
        "args": null,
        "concreteType": "RouteEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [{
          "alias": null,
          "args": null,
          "concreteType": "Route",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [v3 /*: any*/, v7 /*: any*/, v8 /*: any*/, v9 /*: any*/],

          "storageKey": null
        }],
        "storageKey": null
      }],
      "storageKey": null
    },
    v11 = {
      "alias": null,
      "args": v5 /*: any*/,
      "concreteType": "_RouteConnection",
      "kind": "LinkedField",
      "name": "_routes",
      "plural": false,
      "selections": [{
        "alias": null,
        "args": null,
        "concreteType": "_RouteEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [{
          "alias": null,
          "args": null,
          "concreteType": "_Route",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [v3 /*: any*/, v7 /*: any*/, {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "exact",
            "storageKey": null
          }, v8 /*: any*/, {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "handler",
            "storageKey": null
          }, v9 /*: any*/, {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "context",
            "storageKey": null
          }],
          "storageKey": null
        }],
        "storageKey": null
      }],
      "storageKey": null
    },
    v12 = {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    v13 = {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    v14 = [v3 /*: any*/, v13 /*: any*/],
    v15 = {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    };
  return {
    "fragment": {
      "argumentDefinitions": [v0 /*: any*/, v1 /*: any*/, v2 /*: any*/],

      "kind": "Fragment",
      "metadata": null,
      "name": "useBootloaderQuery",
      "selections": [{
        "alias": null,
        "args": null,
        "concreteType": "_Viewer",
        "kind": "LinkedField",
        "name": "_viewer",
        "plural": false,
        "selections": [v3 /*: any*/, {
          "args": v4 /*: any*/,
          "kind": "FragmentSpread",
          "name": "CoreApp__viewer"
        }, {
          "args": v5 /*: any*/,
          "kind": "FragmentSpread",
          "name": "FeatureFlagProvider_features"
        }],
        "storageKey": null
      }, {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [v3 /*: any*/, {
          "args": v5 /*: any*/,
          "kind": "FragmentSpread",
          "name": "CoreApp_viewer"
        }],
        "storageKey": null
      }, {
        "alias": "_tenant",
        "args": v6 /*: any*/,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "_node",
        "plural": false,
        "selections": [{
          "args": null,
          "kind": "FragmentSpread",
          "name": "CoreApp__tenant"
        }],
        "storageKey": null
      }, {
        "alias": "tenant",
        "args": v6 /*: any*/,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [v3 /*: any*/, {
          "args": [{
            "kind": "Variable",
            "name": "configValueKeys",
            "variableName": "configValueKeys"
          }],
          "kind": "FragmentSpread",
          "name": "CoreApp_tenant"
        }, {
          "args": null,
          "kind": "FragmentSpread",
          "name": "CoreNav_nav"
        }],
        "storageKey": null
      }, v10 /*: any*/, v11 /*: any*/],

      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": [v1 /*: any*/, v0 /*: any*/, v2 /*: any*/],

      "kind": "Operation",
      "name": "useBootloaderQuery",
      "selections": [{
        "alias": null,
        "args": null,
        "concreteType": "_Viewer",
        "kind": "LinkedField",
        "name": "_viewer",
        "plural": false,
        "selections": [v3 /*: any*/, {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "tenantCount",
          "storageKey": null
        }, {
          "alias": null,
          "args": v5 /*: any*/,
          "concreteType": "_User",
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": [{
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "code",
            "storageKey": null
          }, v12 /*: any*/, v3 /*: any*/],

          "storageKey": null
        }, {
          "alias": "currentTenantsAndSubtenants",
          "args": v4 /*: any*/,
          "concreteType": "TenantConnectionType",
          "kind": "LinkedField",
          "name": "tenants",
          "plural": false,
          "selections": [{
            "alias": null,
            "args": null,
            "concreteType": "TenantConnectionEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [{
              "alias": null,
              "args": null,
              "concreteType": "_Tenant",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": v14 /*: any*/,
              "storageKey": null
            }],
            "storageKey": null
          }],
          "storageKey": null
        }, {
          "alias": null,
          "args": v5 /*: any*/,
          "concreteType": "Feature",
          "kind": "LinkedField",
          "name": "features",
          "plural": true,
          "selections": [v3 /*: any*/, v8 /*: any*/],

          "storageKey": null
        }],
        "storageKey": null
      }, {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [v3 /*: any*/, {
          "alias": null,
          "args": v5 /*: any*/,
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": [v3 /*: any*/, v13 /*: any*/, {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          }, {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          }, {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          }, {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "displayName",
            "storageKey": null
          }],
          "storageKey": null
        }, {
          "alias": null,
          "args": null,
          "concreteType": "TenantConnection",
          "kind": "LinkedField",
          "name": "tenants",
          "plural": false,
          "selections": [{
            "alias": null,
            "args": null,
            "concreteType": "TenantEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [{
              "alias": null,
              "args": null,
              "concreteType": "Tenant",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": v14 /*: any*/,
              "storageKey": null
            }],
            "storageKey": null
          }],
          "storageKey": null
        }],
        "storageKey": null
      }, {
        "alias": "_tenant",
        "args": v6 /*: any*/,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "_node",
        "plural": false,
        "selections": [v15 /*: any*/, {
          "kind": "InlineFragment",
          "selections": [{
            "alias": null,
            "args": null,
            "concreteType": "Permission",
            "kind": "LinkedField",
            "name": "permissions",
            "plural": true,
            "selections": [{
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "refId",
              "storageKey": null
            }, v8 /*: any*/, v12 /*: any*/],

            "storageKey": null
          }, {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "wrn",
            "storageKey": null
          }],
          "type": "_Tenant",
          "abstractKey": null
        }, v3 /*: any*/],

        "storageKey": null
      }, {
        "alias": "tenant",
        "args": v6 /*: any*/,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [v15 /*: any*/, v3 /*: any*/, {
          "kind": "InlineFragment",
          "selections": [v13 /*: any*/, {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "parentId",
            "storageKey": null
          }, {
            "alias": null,
            "args": null,
            "concreteType": "RoleConnection",
            "kind": "LinkedField",
            "name": "roles",
            "plural": false,
            "selections": [{
              "alias": null,
              "args": null,
              "concreteType": "RoleEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [{
                "alias": null,
                "args": null,
                "concreteType": "Role",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": v14 /*: any*/,
                "storageKey": null
              }],
              "storageKey": null
            }],
            "storageKey": null
          }, {
            "alias": null,
            "args": [{
              "kind": "Variable",
              "name": "keys",
              "variableName": "configValueKeys"
            }],
            "concreteType": "ConfigValue",
            "kind": "LinkedField",
            "name": "config",
            "plural": true,
            "selections": [{
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "key",
              "storageKey": null
            }, {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "value",
              "storageKey": null
            }, v3 /*: any*/],

            "storageKey": null
          }, {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "viewerPermissions",
            "storageKey": null
          }, {
            "alias": null,
            "args": [{
              "kind": "Literal",
              "name": "identifier",
              "value": "ai.workflows.nav.main"
            }],
            "concreteType": "Nav",
            "kind": "LinkedField",
            "name": "nav",
            "plural": false,
            "selections": [{
              "alias": null,
              "args": null,
              "concreteType": "NavItemConnection",
              "kind": "LinkedField",
              "name": "items",
              "plural": false,
              "selections": [{
                "alias": null,
                "args": null,
                "concreteType": "NavItemEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [{
                  "alias": null,
                  "args": null,
                  "concreteType": "NavItem",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [v3 /*: any*/, v13 /*: any*/, v9 /*: any*/, v7 /*: any*/, {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "icon",
                    "storageKey": null
                  }, v8 /*: any*/, {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "externalUrl",
                    "storageKey": null
                  }, {
                    "alias": null,
                    "args": null,
                    "concreteType": "Route",
                    "kind": "LinkedField",
                    "name": "route",
                    "plural": false,
                    "selections": [v7 /*: any*/, v3 /*: any*/],

                    "storageKey": null
                  }],
                  "storageKey": null
                }],
                "storageKey": null
              }],
              "storageKey": null
            }, v3 /*: any*/],

            "storageKey": "nav(identifier:\"ai.workflows.nav.main\")"
          }],
          "type": "Tenant",
          "abstractKey": null
        }],
        "storageKey": null
      }, v10 /*: any*/, v11 /*: any*/]
    },

    "params": {
      "cacheID": "32e789bdf4df3b6276a2574fb1e241ff",
      "id": null,
      "metadata": {},
      "name": "useBootloaderQuery",
      "operationKind": "query",
      "text": "query useBootloaderQuery(\n  $tenantId: ID!\n  $configValueKeys: [String]!\n  $tenantIds: [ID!]\n) {\n  _viewer {\n    id\n    ...CoreApp__viewer_cqBzI\n    ...FeatureFlagProvider_features_1GYzvY\n  }\n  viewer {\n    id\n    ...CoreApp_viewer_1GYzvY\n  }\n  _tenant: _node(id: $tenantId) {\n    __typename\n    ...CoreApp__tenant\n    id\n  }\n  tenant: node(id: $tenantId) {\n    __typename\n    id\n    ...CoreApp_tenant_1NeYjL\n    ...CoreNav_nav\n  }\n  routes(tenantId: $tenantId) {\n    edges {\n      node {\n        id\n        path\n        identifier\n        sort\n      }\n    }\n  }\n  _routes(tenantId: $tenantId) {\n    edges {\n      node {\n        id\n        path\n        exact\n        identifier\n        handler\n        sort\n        context\n      }\n    }\n  }\n}\n\nfragment CoreApp__tenant on _Tenant {\n  permissions {\n    refId\n    identifier\n    type\n  }\n  wrn\n}\n\nfragment CoreApp__viewer_cqBzI on _Viewer {\n  tenantCount\n  user(tenantId: $tenantId) {\n    code\n    type\n    id\n  }\n  currentTenantsAndSubtenants: tenants(tenantIds: $tenantIds) {\n    edges {\n      node {\n        id\n        name\n      }\n    }\n  }\n}\n\nfragment CoreApp_tenant_1NeYjL on Tenant {\n  id\n  name\n  parentId\n  roles {\n    edges {\n      node {\n        id\n        name\n      }\n    }\n  }\n  config(keys: $configValueKeys) {\n    key\n    value\n    id\n  }\n}\n\nfragment CoreApp_viewer_1GYzvY on Viewer {\n  id\n  user(tenantId: $tenantId) {\n    id\n    name\n    email\n    firstName\n    lastName\n    displayName\n  }\n  tenants {\n    edges {\n      node {\n        id\n        name\n      }\n    }\n  }\n}\n\nfragment CoreNav_nav on Tenant {\n  viewerPermissions\n  nav(identifier: \"ai.workflows.nav.main\") {\n    items {\n      edges {\n        node {\n          id\n          name\n          sort\n          path\n          icon\n          identifier\n          externalUrl\n          route {\n            path\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment FeatureFlagProvider_features_1GYzvY on _Viewer {\n  features(tenantId: $tenantId) {\n    id\n    identifier\n  }\n}\n"
    }
  };
}();
(node as any).hash = "08a8c0b198e70db3fe659ca53594dcd3";
export default node;